import { createReducer } from "redux-create-reducer";

import {
  GET_MULTIPLE_CLIENTS_REPORT,
  SET_MULTIPLE_CLIENTS_REPORT_FILTERS,
  CLEAR_MULTIPLE_CLIENTS_REPORT,
} from "../types";

const initialState = {
  data: {},
  filters: {
    from: null,
    to: null,
    clientStatus: null,
    scoringStatus: null,
    riskLevel: null,
    falsePositiveMarker: null,
    trueMatchMarker: null,
    clientType: null,
  },
  entries: [],
  isLoading: false,
};

const multipleClientsReportReducer = createReducer(initialState, {
  [SET_MULTIPLE_CLIENTS_REPORT_FILTERS]: (state, { payload }) => ({
    ...initialState,
    clientTypes: state.clientTypes,
    filters: { ...state.filters, ...payload },
  }),
  [GET_MULTIPLE_CLIENTS_REPORT.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_MULTIPLE_CLIENTS_REPORT.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_MULTIPLE_CLIENTS_REPORT.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_MULTIPLE_CLIENTS_REPORT.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: payload.data,
    isLoading: false,
  }),

  [CLEAR_MULTIPLE_CLIENTS_REPORT]: () => ({ ...initialState }),
});

export default multipleClientsReportReducer;



// WEBPACK FOOTER //
// ./src/features/reports/reducers/multipleClientsReportReducer.js